<template>
  <toggle-button
    v-bind="{ ...$props, ...$attrs }"
    @change="onChange" />
</template>

<script setup lang="ts">
  import ToggleButton from '@/common/components/controls/ToggleButton.vue';
  import { LineItem } from '@/common/models';
  import { mapActions } from '@/utils/StateMapping';
  import { ComponentProps } from '@/utils/TypescriptUtils';

  // eslint-disable-next-line
  interface ToggleProps extends /* @vue-ignore */ ComponentProps<typeof ToggleButton> {}
  type Props = ToggleProps & {
    entity: LineItem;
    featureKey: string;
    transient?: boolean;
  };
  const props = defineProps<Props>();
  const emits = defineEmits(['change']);
  const { updateLineItemAddFeatureKey, updateLineItemRemoveFeatureKey } = mapActions();

  function onChange(value: boolean) {
    updateEntityFeatures(value);
    emits('change', value);
  }
  function updateEntityFeatures(isEnabled: boolean) {
    if (props.entity instanceof LineItem) {
      const value = [
        {
          key: props.featureKey,
          transient: props.transient,
        },
      ];
      if (isEnabled) {
        updateLineItemAddFeatureKey({
          lineItem: props.entity,
          value,
        });
      } else {
        updateLineItemRemoveFeatureKey({
          lineItem: props.entity,
          value,
        });
      }
    }
  }
</script>
